export class ImageUploadModel {
    existsGuids: string[];
    addedFiles: File[];
    deletedGuids: string[];
}
